import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
import { themeTokens, resetStyles } from '../../styles/tokens.css.js';

@customElement('yebo-loading-spinner')
export class YeboLoadingSpinner extends LitElement {
  static styles = [
    themeTokens,
    resetStyles,
    css`
      :host {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: var(--yebo-space-lg);
      }
      .spinner {
        width: 28px;
        height: 28px;
        border: 3px solid var(--yebo-border);
        border-top-color: var(--yebo-primary);
        border-radius: 50%;
        animation: spin 0.7s linear infinite;
      }
      @keyframes spin {
        to { transform: rotate(360deg); }
      }
      @media (prefers-reduced-motion: reduce) {
        .spinner { animation: none; }
      }
    `,
  ];

  render() {
    return html`<div class="spinner" role="status" aria-label="Loading"></div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'yebo-loading-spinner': YeboLoadingSpinner;
  }
}
